import moment from 'moment/moment'
import {DATE_FORM_FORMAT} from '@/constants/date'

export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    createdAt: {
      value: `${moment().format(DATE_FORM_FORMAT)} 00:00:00|${
        moment().format(DATE_FORM_FORMAT)} 23:59:59`,
      operator: 'bwn',
    },
    clickId: {
      value: '',
      operator: 'like'
    },
    innerClickId: {
      value: '',
      operator: 'like'
    },
    segment: {
      value: '',
      operator: 'like'
    },
    outerId: {
      value: '',
      operator: 'like'
    },
    siteId: {
      value: '',
      operator: 'like'
    },  
    offerPartnerLanding: {
      value: '',
      operator: 'in'
    },
    partner: {
      id: {
        value: '',
        operator: 'in',
      },
    },
    advertiser: {
      id: {
        value: '',
        operator: 'in',
      },
    },
    country: {
      id: {
        value: '',
        operator: 'in',
      }
    },
    trafficSource: {
      value: '',
      operator: 'in'
    },
    geoCountry: {
      value: '',
      operator: 'in'
    },
    retargeting: {
      value: '',
      operator: 'in'
    },
  },
  custom_filter: {
    search: ''
  },
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: false,
  },
})
